import React, { useState } from 'react';
import { DoctrinePredictionTable } from './DoctrinePredictionTable';
import { SubsistenceUsageRateGraph } from './SubsistenceUsageRateGraph';
import { WaterUsageRateGraph } from './WaterUsageRateGraph';
import { WaterConsumptionTable } from './WaterConsumptionTable';
export const ClassIDetails: React.FC = () => {
  const [perishableBoxes, setPerishableBoxes] = useState(192);
  const [nonPerishableBoxes, setNonPerishableBoxes] = useState(384);
  // Initial food doctrine data
  const initialFoodDoctrineData = [{
    day: 'current',
    soldiers: 3200,
    perishableRate: 0.06,
    nonPerishableRate: 0.12,
    totalBoxes: 576,
    boxesLeft: 3424,
    capacity: 4000,
    percentLeft: 85.6
  }, {
    day: '1',
    soldiers: 3200,
    perishableRate: 0.06,
    nonPerishableRate: 0.12,
    totalBoxes: 576,
    boxesLeft: 2848,
    capacity: 4000,
    percentLeft: 71.2
  }, {
    day: '2',
    soldiers: 3200,
    perishableRate: 0.06,
    nonPerishableRate: 0.12,
    totalBoxes: 576,
    boxesLeft: 2272,
    capacity: 4000,
    percentLeft: 56.8
  }, {
    day: '3',
    soldiers: 3200,
    perishableRate: 0.06,
    nonPerishableRate: 0.12,
    totalBoxes: 576,
    boxesLeft: 1696,
    capacity: 4000,
    percentLeft: 42.4
  }, {
    day: '4',
    soldiers: 3200,
    perishableRate: 0.06,
    nonPerishableRate: 0.12,
    totalBoxes: 576,
    boxesLeft: 4000,
    capacity: 4000,
    percentLeft: 100.0
  }, {
    day: '5',
    soldiers: 3200,
    perishableRate: 0.06,
    nonPerishableRate: 0.12,
    totalBoxes: 576,
    boxesLeft: 3424,
    capacity: 4000,
    percentLeft: 85.6
  }];
  // State for resupply days
  const [resupplyDays, setResupplyDays] = useState<{
    [key: string]: boolean;
  }>({
    '4': true
  });
  // Handle resupply checkbox changes
  const handleResupplyChange = (day: string, checked: boolean) => {
    setResupplyDays(prev => ({
      ...prev,
      [day]: checked
    }));
  };
  // State for water resupply days
  const [waterResupplyDays, setWaterResupplyDays] = useState<{
    [key: string]: boolean;
  }>({
    '4': true
  });
  // Handle water resupply checkbox changes
  const handleWaterResupplyChange = (day: string, checked: boolean) => {
    setWaterResupplyDays(prev => ({
      ...prev,
      [day]: checked
    }));
  };
  // Food doctrine data with resupply information
  const foodDoctrineData = initialFoodDoctrineData.map(row => ({
    ...row,
    totalBoxes: perishableBoxes + nonPerishableBoxes,
    resupply: resupplyDays[row.day] || false
  }));
  // Historical food usage data
  const foodHistoricalData = [{
    day: '-5',
    actualBoxes: 650,
    doctrineBoxes: 576
  }, {
    day: '-4',
    actualBoxes: 660,
    doctrineBoxes: 576
  }, {
    day: '-3',
    actualBoxes: 667,
    doctrineBoxes: 576
  }, {
    day: '-2',
    actualBoxes: 665,
    doctrineBoxes: 576
  }, {
    day: '-1',
    actualBoxes: 670,
    doctrineBoxes: 576
  }];
  // Water prediction data
  const waterPredictionData = [{
    day: 'current',
    gallonsUsed: 571080,
    gallonsLeft: 2928920,
    capacity: 3800000,
    percentOnHand: 77.08
  }, {
    day: '1',
    gallonsUsed: 571080,
    gallonsLeft: 2357840,
    capacity: 3800000,
    percentOnHand: 62.05
  }, {
    day: '2',
    gallonsUsed: 571080,
    gallonsLeft: 1786760,
    capacity: 3800000,
    percentOnHand: 47.02
  }, {
    day: '3',
    gallonsUsed: 571080,
    gallonsLeft: 1215680,
    capacity: 3800000,
    percentOnHand: 31.99
  }, {
    day: '4',
    gallonsUsed: 571080,
    gallonsLeft: 3800000,
    capacity: 3800000,
    percentOnHand: 100.0
  }, {
    day: '5',
    gallonsUsed: 571080,
    gallonsLeft: 3228920,
    capacity: 3800000,
    percentOnHand: 85.0
  }];
  // Historical water usage data
  const waterHistoricalData = [{
    day: '-5',
    actualGallons: 580231,
    doctrineGallons: 571080
  }, {
    day: '-4',
    actualGallons: 578293,
    doctrineGallons: 571080
  }, {
    day: '-3',
    actualGallons: 585214,
    doctrineGallons: 571080
  }, {
    day: '-2',
    actualGallons: 592314,
    doctrineGallons: 571080
  }, {
    day: '-1',
    actualGallons: 582204,
    doctrineGallons: 571080
  }];
  return <div className="py-4 px-6 bg-gray-50 border-t border-gray-200" data-id="element-648">
      <div className="mb-8" data-id="element-649">
        <h3 className="text-lg font-medium text-gray-900 mb-4" data-id="element-650">
          Food Consumption Prediction
        </h3>
        <div className="flex flex-col lg:flex-row gap-6" data-id="element-651">
          <div className="lg:w-2/3" data-id="element-652">
            <h4 className="text-sm font-medium text-gray-700 mb-2" data-id="element-653">
              Doctrine-based Prediction:
            </h4>
            <DoctrinePredictionTable data={foodDoctrineData} onResupplyChange={handleResupplyChange} data-id="element-654" />
          </div>
          <div className="lg:w-1/3 bg-white p-4 border border-gray-200 rounded-md" data-id="element-655">
            <h4 className="text-sm font-medium text-gray-700 mb-2" data-id="element-656">
              Current Assumptions:
            </h4>
            <div className="space-y-3" data-id="element-657">
              <div data-id="element-658">
                <label className="block text-xs text-gray-500" data-id="element-659">
                  Perishable boxes / day
                </label>
                <input type="number" value={perishableBoxes} onChange={e => setPerishableBoxes(Number(e.target.value))} className="w-full border border-gray-300 rounded px-3 py-2 text-sm bg-yellow-100 text-blue-600" data-id="element-660" />
              </div>
              <div data-id="element-661">
                <label className="block text-xs text-gray-500" data-id="element-662">
                  Nonperishable boxes / day
                </label>
                <input type="number" value={nonPerishableBoxes} onChange={e => setNonPerishableBoxes(Number(e.target.value))} className="w-full border border-gray-300 rounded px-3 py-2 text-sm bg-yellow-100 text-blue-600" data-id="element-663" />
              </div>
              <div data-id="element-664">
                <label className="block text-xs text-gray-500" data-id="element-665">
                  Total boxes / day
                </label>
                <div className="pt-2 border-t border-gray-400 mt-1" data-id="element-666">
                  <div className="w-full bg-gray-100 border border-gray-300 rounded px-3 py-2 text-sm text-black font-bold" data-id="element-667">
                    {perishableBoxes + nonPerishableBoxes}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="mt-6" data-id="element-668">
          <h4 className="text-sm font-medium text-gray-700 mb-2" data-id="element-669">
            Historical Usage vs. Doctrine:
          </h4>
          <SubsistenceUsageRateGraph data={foodHistoricalData} valueKey="Boxes" data-id="element-670" />
        </div>
      </div>
      <div className="border-t border-gray-200 pt-8" data-id="element-671">
        <h3 className="text-lg font-medium text-gray-900 mb-4" data-id="element-672">
          Water Consumption Prediction
        </h3>
        <div className="mb-6" data-id="element-673">
          <h4 className="text-sm font-medium text-gray-700 mb-2" data-id="element-674">
            Doctrine-based Water Requirements (HOT, ARID climate):
          </h4>
          <WaterConsumptionTable data-id="element-675" />
        </div>
        <div className="mb-6" data-id="element-676">
          <h4 className="text-sm font-medium text-gray-700 mb-2" data-id="element-677">
            Water Consumption Prediction:
          </h4>
          <div className="overflow-x-auto bg-white border border-gray-200 rounded-md" data-id="element-678">
            <table className="min-w-full divide-y divide-gray-200" data-id="element-679">
              <thead className="bg-gray-50" data-id="element-680">
                <tr data-id="element-681">
                  <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-682">
                    Day
                  </th>
                  <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-683">
                    Gallons Used/Day
                  </th>
                  <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-684">
                    Resupply
                  </th>
                  <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-685">
                    Gallons Left
                  </th>
                  <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-686">
                    Capacity
                  </th>
                  <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-687">
                    % On Hand (Pred)
                  </th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200" data-id="element-688">
                {waterPredictionData.map((row, index) => <tr key={index} className={index % 2 === 0 ? 'bg-white' : 'bg-gray-50'} data-id="element-689">
                    <td className="px-4 py-2 whitespace-nowrap text-sm text-gray-900" data-id="element-690">
                      {row.day}
                    </td>
                    <td className="px-4 py-2 whitespace-nowrap text-sm text-gray-700" data-id="element-691">
                      <div className="bg-gray-100 border border-gray-300 rounded px-3 py-1 text-black font-bold inline-block" data-id="element-692">
                        {row.gallonsUsed.toLocaleString()}
                      </div>
                    </td>
                    <td className="px-4 py-2 whitespace-nowrap text-sm text-gray-700 text-center" data-id="element-693">
                      <input type="checkbox" checked={waterResupplyDays[row.day] || false} onChange={e => handleWaterResupplyChange(row.day, e.target.checked)} className="h-4 w-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500 cursor-pointer" data-id="element-694" />
                    </td>
                    <td className="px-4 py-2 whitespace-nowrap text-sm text-gray-700" data-id="element-695">
                      {row.gallonsLeft.toLocaleString()}
                    </td>
                    <td className="px-4 py-2 whitespace-nowrap text-sm text-gray-700" data-id="element-696">
                      {row.capacity.toLocaleString()}
                    </td>
                    <td className="px-4 py-2 whitespace-nowrap text-sm text-gray-700" data-id="element-697">
                      {row.percentOnHand.toFixed(2)}%
                    </td>
                  </tr>)}
              </tbody>
            </table>
          </div>
        </div>
        <div className="mt-6" data-id="element-698">
          <h4 className="text-sm font-medium text-gray-700 mb-2" data-id="element-699">
            Historical Water Usage vs. Doctrine:
          </h4>
          <WaterUsageRateGraph data={waterHistoricalData} valueKey="Gallons" data-id="element-700" />
          <div className="mt-2" data-id="element-701">
            <a href="#" className="text-blue-600 text-sm hover:underline" data-id="element-702">
              More usage details →
            </a>
          </div>
        </div>
      </div>
    </div>;
};